import { type ComponentProps, useMemo } from 'react';
import { type FormattedTimeConfig, HeartbeatIcon } from 'ui';
import { type ActivityTodo, isActivityAvailable } from '../../../../types';
import { BaseTodoWidgetItem } from '../base-todo-widget-item';
import { CompleteNowItem } from './complete-now-item';

type P = {
  className?: string;
  todo: ActivityTodo;
  type?: ComponentProps<typeof BaseTodoWidgetItem>['type'];
};

const ActivityTodoWidgetItem = ({ className, todo, type }: P) => {
  const { activity, endTime, path } = todo;
  const { currentActivityTime, description, name, periodicityType, times } = activity;

  const options: FormattedTimeConfig['options'] = useMemo(() => {
    if (periodicityType === 'daily' && times.length > 0) {
      return { display: 'time', mode: 'at' };
    }

    if (periodicityType === 'one_time') {
      return { display: 'time', mode: 'by' };
    }

    return { display: 'hidden' };
  }, [periodicityType, times.length]);

  const time = useMemo(() => {
    if (currentActivityTime && options.display === 'time' && options.mode === 'at') {
      return currentActivityTime;
    }

    return endTime;
  }, [endTime, options, currentActivityTime]);

  return (
    <BaseTodoWidgetItem
      additionalDescription={description}
      className={className}
      description={name}
      icon={<HeartbeatIcon />}
      item={currentActivityTime && isActivityAvailable(currentActivityTime) ? <CompleteNowItem /> : null}
      path={path}
      timeConfig={{ options, time }}
      title="Complete activity"
      type={type}
    />
  );
};

export default ActivityTodoWidgetItem;
